// yadsPatchTenantReducer.js
import {
  PATCH_YADS_TENANT_REQUEST,
  PATCH_YADS_TENANT_SUCCESS,
  PATCH_YADS_TENANT_FAILURE,
  PATCH_YADS_TENANT_RESET,
} from '../../../Constants/actionTypes';

const initialPatch = {
  loading: false,
  result: null,
  error: '',
};

const yadsPatchTenantReducer = (state = initialPatch, action) => {
  switch (action.type) {
    case PATCH_YADS_TENANT_REQUEST:
      return { ...state, loading: true, error: '' };
    case PATCH_YADS_TENANT_SUCCESS:
      return { loading: false, result: action.payload, error: '' };
    case PATCH_YADS_TENANT_FAILURE:
      return { loading: false, result: null, error: action.payload };
    case PATCH_YADS_TENANT_RESET:
      return initialPatch;
    default:
      return state;
  }
};

export default yadsPatchTenantReducer;
